import { Inject, Injectable } from '@angular/core';
import { Enjoyment } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class EnjoymentStore extends DefaultRessourceStore<Enjoyment> {
    constructor(@Inject(getCrudName(Enjoyment)) protected crudService: GenericCrudService<Enjoyment>) { super(crudService) }
}